import { mprConstants } from '../Constants';

const mpr = (mpr) => {
  return {
    type: mprConstants.MPR_SUCCESS,
    payload: mpr
  }
}

const mprData = (mpr_data) => {
	return {
		type: mprConstants.MPR_DATA_SUCCESS,
		payload: mpr_data
	}
}

// const basicInformation = (mpr) => {
//   return {
//     type: mprConstants.BASIC_INFORMATION_SUCCESS,
//     payload: mpr
//   }
// }

// const researchBackgroundSave = (res, mpr) => {
//   mpr.research_background = res.data.research_background;
//   localStorage.setItem("mpr", JSON.stringify(mpr));
//   return this.mpr(mpr);  
// }

export const mprActions = {
  mpr,
  mprData,
  // basicInformation,
  // researchBackgroundSave
};